<template>
    <div v-route-title="'栏目管理'">
        <div v-if="view === 'main'">
            <div class="database-view">
                <div class="header-view pr">
                    <span class="huishouzhan_title">栏目管理</span>
                    <div class="btn-layer">
                        <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">添加栏目</el-button>
                    </div>
                </div>
                <el-form class="search-form" inline :model="searchModel">
                    <el-form-item>
                        <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="栏目ID"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="栏目名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="searchModel.type" multiple clearable placeholder="栏目类型">
                            <el-option v-for="type in sectionTypes" :key="type.type" :value="type.type" :label="type.typeName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="search">搜索</el-button>
                    </el-form-item>
                </el-form>
                <div v-if="data">
                    <el-table class="yq-table" :data="data.content" style="width: 100%">
                        <el-table-column
                                type="index"
                                :index="indexMethod">
                        </el-table-column>
                        <el-table-column
                                prop="id"
                                label="ID">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="栏目名称">
                        </el-table-column>
                        <el-table-column
                                prop="type"
                                label="栏目类型">
                            <span slot-scope="scope">{{getSectionType(scope.row.type).typeName}}</span>
                        </el-table-column>
                        <el-table-column
                                label="创建时间">
                            <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                        </el-table-column>
                        <el-table-column
                                label="创建用户">
                            <span slot-scope="scope">{{scope.row.creatorUser?scope.row.creatorUser.name:''}}</span>
                        </el-table-column>
                        <el-table-column
                                label="修改时间">
                            <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                        </el-table-column>
                        <el-table-column
                                label="修改用户">
                            <span slot-scope="scope">{{scope.row.editorUser?scope.row.editorUser.name:''}}</span>
                        </el-table-column>
                        <el-table-column
                                label="操作" width="180">
                            <template slot-scope="scope">
                                <el-link icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                                <el-link icon="el-icon-setting" @click="configRow(scope.row)">配置</el-link>
                                <el-link icon="el-icon-setting" v-if="hasAuthority('T_前台用户') && scope.row.type==='news'" @click="subscriptionConfig(scope.row)">推送配置</el-link>
                                <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="clear"></div>
            <div class="magin10"></div>
            <div class="foot" v-if="data">
                <el-pagination
                        layout="prev, pager, next" background
                        :total="data.totalElements" :current-page="data.number+1"
                        @current-change="fetchData($event)">
                </el-pagination>
            </div>
        </div>
        <div v-if="view === 'config'" style="padding: 0 20px;">
            <section-config :id="section.id" @close="onSectionConfigClose"></section-config>
        </div>
        <div v-if="view === 'subscription-config'" style="padding: 0 20px;">
            <section-subscription-config :section-id="section.id" @close="view='main'"></section-subscription-config>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改记录':'添加记录'" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="model" label-width="120px" :rules="rules">
                <el-form-item label="栏目名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="栏目类型" prop="type">
                    <el-select v-model="model.type">
                        <el-option v-for="type in sectionTypes" :key="type.type" :value="type.type" :label="type.typeName"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import sectionService from '../service/section'
    import sectionTypeService from '../service/section-type'
    import SectionConfig from '../components/sections/SectionConfig'
    import SectionSubscriptionConfig from "../components/sections/SectionSubscriptionConfig";
    import {mapGetters} from "vuex";

    export default {
        name: "SectionAdmin",
        components: {SectionConfig, SectionSubscriptionConfig},
        data() {
            return {
                view: 'main',
                data: null,
                searchModel: {
                    id: null,
                    nameLike: null,
                    type: null
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    type: null
                },
                dialogFormVisible: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入栏目名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择栏目类型', trigger: 'blur'}
                    ]
                },
                sectionTypes: [],
                section: null
            }
        },
        computed: {
            ...mapGetters(['hasAuthority', 'hasAnyAuthority'])
        },
        created(){
            this.init()
        },
        methods: {
            init(){
                sectionTypeService.getAssignedSectionTypes().then(sectionTypes => {
                    this.sectionTypes = sectionTypes
                })
                this.fetchData(1)
            },
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await sectionService.listSections(params)
                this.data = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow(){
                this.model = {
                    name: null,
                    type: null
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                sectionService.getSection(row.id).then(response => {
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    if (this.model.id) {
                        sectionService.updateSection(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        sectionService.addSection(this.model).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number+1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(()=>{})
            },
            deleteRow(row){
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    sectionService.deleteSection(row.id).then(()=>{
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number>0?this.data.number:1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(()=>{
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            getSectionType(type){
                return sectionTypeService.getSectionType(type)
            },
            configRow(row) {
                this.section = row
                this.view = 'config'
            },
            subscriptionConfig(row) {
                this.section = row
                this.view = 'subscription-config'
            },
            async onSectionConfigClose(){
                const index = this.data.content.indexOf(this.section)
                const response = await sectionService.getSection(this.section.id)
                this.data.content.splice(index, 1, response.data)
                this.view = 'main'
                this.section = null
            }
        }
    }
</script>
<style scoped>
</style>
